import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-seperation-policies',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule,LoaderComponent],
  templateUrl: './seperation-policies.component.html',
  styleUrl: './seperation-policies.component.scss'
})
export class SeperationPoliciesComponent {
isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    //private shift: ShiftService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private toast: ToastService,
    private download: DownloadSampleService
  ) {
    common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_SeperationRuleLoadGet();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_SeperationRuleLoadGet() {
    //this.isDisabled = true;
    // this.shift.ESS_ShiftRuleLoadGet({ SelectType: 1, ESS_ShiftRuleID: 0 }).subscribe({
    //   next: (response) => {
    //     this.TableDatas = Object.values(response.Table);
    //     this.TableDatas.forEach((element:any) => {
    //       element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
    //     });
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //     this.isDisabled = false;
    //   },
    //   complete: () => { },
    //   error: (error) => {
    //     this.isDisabled = false;
    //   },
    // });
  }
  // exportToExcel() {
  //   this.isDisabled = true
  //   const data = {
  //     SelectType: 'ShiftPolicyMasterExcel',
  //     Year: ''
  //   }
  //   this.download.ESS_ExcelDump(data).subscribe(
  //     data => {
  //       this.ShiftData = data;
  //       if (this.ShiftData.length > 0) {
  //         this.download.exportToExcel(this.ShiftData, "ShiftRulePolicies_data");
  //         this.isDisabled = false;
  //       }
  //       else {
  //         this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
  //         this.isDisabled = false;
  //       }

  //     });
  // }
}
